module.exports = __webpack_public_path__ + "img/lethargy.1bb16ff3.jpg";